module.exports = __webpack_public_path__ + "@/assets/img/cursoIA-background.e971b5a2.png";